import { render, staticRenderFns } from "./menuitem.vue?vue&type=template&id=4835b9c2&"
import script from "./menuitem.vue?vue&type=script&lang=js&"
export * from "./menuitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4835b9c2')) {
      api.createRecord('4835b9c2', component.options)
    } else {
      api.reload('4835b9c2', component.options)
    }
    module.hot.accept("./menuitem.vue?vue&type=template&id=4835b9c2&", function () {
      api.rerender('4835b9c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Header/menuitem.vue"
export default component.exports